import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { log, revokeAccessToken } from '@api/ccc-api-calls'
import { selectors as transactionSelectors } from '@modules/transaction'
import { selectors as authSelectors } from '@modules/auth'
import Loader from '@components/loader'
import { useIsContentOverflowing } from '@hooks/use-is-content-overflowing'

const EaseRedirection = () => {
  const { t } = useTranslation()
  const bodyElement = document.querySelector('body')
  const [contentContainerRef] = useIsContentOverflowing(bodyElement, 2, [[0, e => e.offsetTop]])
  const kioskName = useSelector(transactionSelectors.kioskName)
  const clientCorrelationId = useSelector(transactionSelectors.clientCorrelationId)
  const accessToken = useSelector(authSelectors.accessToken)
  const isAuthenticated = useSelector(authSelectors.isAuthenticated)

  useEffect(() => {
    setTimeout(() => {
      log(kioskName, clientCorrelationId, 'TRANSITIONING TO EASE DEEP LINK', accessToken)
      if (isAuthenticated) {
        revokeAccessToken(accessToken)
      }
      /* eslint-disable-next-line no-restricted-globals */
      location.replace(
        `${process.env.REACT_APP_EASE_REDIRECT}?action=CCK&deviceId=${kioskName}&transactionId=${clientCorrelationId}`
      )
    }, 7000)
  }, [])

  return (
    <>
      <div ref={contentContainerRef} className='content-container'>
        <h2 id='check-confirmation-header' className='content-title'>
          {t('easeRedirection.header')}
        </h2>

        <p className='subheader'>{t('easeRedirection.subheader')}</p>

        <Loader additionalClass='small' />
      </div>
    </>
  )
}

export default EaseRedirection
